import React, { Component } from "react"
import Login from "./containers/Login"
import ResetPassword from "./containers/ResetPassword"
import ForgetPassword from "./containers/ForgetPassword"
import stores from "app/stores"
import { observer, inject } from "mobx-react"
import "./Index.scss"

const FORM_MAP = {
  login: <Login />,
  resetPassword: <ResetPassword />,
  forgetPassword: <ForgetPassword />
}

@inject("auth")@observer
export default class Index extends Component {
  render() {
    return (
      <div className="login-container">
        <h1 className="logo-img">PGXCLOUD</h1>
        {React.cloneElement(FORM_MAP[stores.auth.formType], {auth: this.props.auth})}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/index.js